import axios from "axios";
import React, { forwardRef, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import SocialShare from "./SocialShare";
import useIntersectionObserver from "./useHook";
import { useNavigate } from "react-router-dom";

const VideoElement = forwardRef(
  ({ product, products, setProduct, index, video, muted, videoId, setMuted }, ref) => {
    const isMobile =
      /Mobile|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    const navigate = useNavigate();
    const videoRef = useRef(null);
    const [shareModal, setShareModal] = useState(false);
    const [shareId, setShareId] = useState(false);
    const [shareLoading, setShareLoading] = useState(false);
    const [likeLoading, setLikeLoading] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);

    const handleShare = async (videoId) => {
      setShareLoading(true);
      await axios
        .get(
          `${process.env.REACT_APP_BASEURL}user/shareVideo/share?productId=${product.product._id}&videoId=${videoId}`
        )
        .then((res) => {
          setProduct(
            products.map((item) =>
              item.product.videos._id !== videoId
                ? item
                : {
                    product: {
                      ...item.product,
                      videos: {
                        ...item.product.videos,
                        shares: item.product.videos.shares + 1,
                      },
                    },
                  }
            )
          );
          setShareId("");
          setShareLoading(false);
        })
        .catch((error) => {
          setShareLoading(false);
          toast.error(error.response.data.message);
        });
    };
    const handleLike = async (videoId) => {
      setLikeLoading(true);
      await axios
        .get(
          `${process.env.REACT_APP_BASEURL}user/likeVideo/toogleLike?productId=${product.product._id}&videoId=${videoId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        )
        .then((res) => {
          setProduct(
            products.filter((item) => item.product.videos._id !== videoId)
          );
          if (products.length === 1) {
            navigate("/favourites");
          }
          setLikeLoading(false);
        })
        .catch((error) => {
          setLikeLoading(false);
          toast.error(error.response.data.message);
        });
    };
    const handleDownload = async (videoUrl) => {
      setDownloadLoading(true);
      await axios
        .get(
          `${process.env.REACT_APP_BASEURL}user/downloadVideo/download?productId=${product.product._id}&videoId=${videoUrl}`
        )
        .then(function () {
          setDownloadLoading(false);
          const url = videoUrl;
          const a = document.createElement("a");
          a.href = url;
          a.download = "video.mp4";
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          setProduct(
            products.map((item) =>
              item.product.videos._id !== videoUrl
                ? item
                : {
                    product: {
                      ...item.product,
                      videos: {
                        ...item.product.videos,
                        downloads: item.product.videos.downloads + 1,
                      },
                    },
                  }
            )
          );
        })

        .catch(function (error) {
          setDownloadLoading(false);
          console.error("API call error:", error);
        });
    };
    const componentRef = useRef(null);
    const componentRefWithIntersection = (element) => {
      componentRef.current = element;
      setNodeRef(element);
    };
    const [setNodeRef, entry] = useIntersectionObserver({
      threshold: 0.5,
    });

    const shareData = {
      title: "BioSOUTH",
      text: `Check out this awesome video! ${video.title}`,
      url: window.location.href.replace(/favourite-videos/, "video"),
    };

    const handleShareClick = (shareId) => {
      if (navigator.share) {
        navigator
          .share(shareData)
          .then(() => {
            handleShare(shareId);

            console.log("Shared successfully");
          })
          .catch((error) => {
            console.error("Error sharing:", error);
          });
      }
    };

    useEffect(() => {
      if (videoRef.current) {
        if (entry.isIntersecting) {
          videoRef.current.play();
        } else {
          videoRef.current.load();
        }
      }
    }, [entry, videoRef, entry.isIntersecting]);

    return (
      <div ref={componentRefWithIntersection} key={index}>
        {shareModal && (
          <SocialShare
            setShareModal={setShareModal}
            handleShare={handleShare}
            shareLoading={shareLoading}
            isFavourite={true}
            shareId={shareId}
          />
        )}
        <div id={video._id}></div>
        <section
          className={"tik_tok_vedio_without_header"}
          key={index}
          style={{ height: window.innerHeight }}
        >
          <div
            className="about-video-wrapper"
            style={{ height: "100vh", borderRadius: "0px" }}
          >
            <video
              id="videoPlayer"
              ref={videoRef}
              controls={false}
              loop
              muted={muted}
              webkit-playsinline
              playsInline
              style={{ objectFit: "cover" }}
            >
              <source
                src={process.env.REACT_APP_BUCKET_BASE_URL + video.video}
                type="video/mp4"
              />{" "}
            </video>
            <div className="container">
              {" "}
              <div className="social_icon_btn">
                <ul className="bg-social">
                  <div>
                    <li className="mb-3">
                      <Link to={`/favourites`}>
                        <p>
                          <img
                            src="assets/images/cross.svg"
                            alt="cros"
                            class="img-fluid"
                          />
                        </p>
                      </Link>
                    </li>
                    <li>
                      <p
                        onClick={() => {
                          if (isMobile) {
                            handleShareClick(video._id);
                          } else {
                            setShareId(video._id);
                            setShareModal(true);
                          }
                        }}
                      >
                        <img
                          src="assets/images/share.svg"
                          alt="share"
                          className="img-fluid"
                        />
                      </p>
                      <span className=" text-white text-center">
                        {video.shares}
                      </span>
                    </li>
                    <li>
                      <p
                        onClick={() => {
                          if (localStorage.getItem("token")) {
                            if (!likeLoading) handleLike(video._id);
                          }
                        }}
                      >
                        <img
                          src={
                            video.isLike
                              ? "assets/images/liked.svg"
                              : "assets/images/heart.svg"
                          }
                          alt="heart"
                          className="img-fluid"
                        />
                      </p>
                      <span className=" text-white text-center">
                        {video.likes}
                      </span>
                    </li>
                    {/* <li>
            <p>
              <img
                src="assets/images/comment.svg"
                alt="comment"
                className="img-fluid"
              />
            </p>
            <span className=" text-white text-center">6.7k</span>
          </li> */}
                    <li>
                      <p
                        onClick={() => {
                          if (!downloadLoading)
                            handleDownload(
                              video._id,
                              process.env.REACT_APP_BUCKET_BASE_URL +
                                video.video
                            );
                        }}
                      >
                        <img
                          src="assets/images/download.svg"
                          alt="download"
                          className="img-fluid"
                        />
                      </p>
                      <span className=" text-white text-center">
                        {video.downloads}
                      </span>
                    </li>
                    {products && products.length > 0 && (
                      <li
                        className="mb-3 d-flex justify-content-center align-items-center"
                        style={{
                          width: "50px",
                          height: "50px",
                          borderRadius: "100%",
                        }}
                        onClick={() => {
                          setMuted(!muted);
                        }}
                      >
                        {muted ? (
                          <i
                            class="text-white fa fa-2x fa-volume-off"
                            aria-hidden="true"
                          ></i>
                        ) : (
                          <i
                            class="text-white fa fa-2x fa-volume-up"
                            aria-hidden="true"
                          ></i>
                        )}
                      </li>
                    )}
                  </div>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
);

export default VideoElement;
